import React from 'react';
import { object } from 'prop-types';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import OlxProKnowMore from './OlxProKnowMore';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 290px;
  justify-content: space-between;
  margin: 10px 15px;
`;

const Image = styled.img`
  width: 48px;
  height: 48px;
`;

const TextBox = styled.div`
  width: 220px;
`;

const Title = styled.h3`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 19.1px;
  font-weight: 800;
  line-height: 1.47;
  margin-bottom: 8px;
  color: #4a4a4a;
  ${({ olxpro }) => (olxpro ? 'padding-right: 15px' : '')}
`;

const Description = styled(ReactMarkdown)`
  * {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #4a4a4a;
    font-weight: 600;
  }

  strong {
    font-weight: bold;
  }
`;

const BenefitItem = ({ benefit }) => (
  <Container>
    <Image src={`${process.env.PUBLIC_URL}/images/${benefit.icon}.svg`} alt={benefit.title} />
    <TextBox>
      <Title olxpro={benefit.olxpro}>{benefit.title}</Title>
      <Description source={benefit.description} />
      {benefit.olxpro && <OlxProKnowMore />}
    </TextBox>
  </Container>
);

export default BenefitItem;

BenefitItem.propTypes = {
  benefit: object.isRequired,
};
